import * as Yup from 'yup';

export default Yup.object()
  .shape({
    date: Yup.string().required('La data dell\'appuntamento è obbligatoria'),
    time: Yup.string().required('L\'ora dell\'appuntamento è obbligatoria'),
    notes: Yup.string().notRequired(),
    status: Yup.string().required('Lo stato dell\'appuntamento è richiesto'),
  });
